module.exports = __webpack_public_path__ + "static/media/hero-mobile.7447dc16.jpg";